<svg width="24" height="24" viewBox="0 0 24 24" fill="current" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18 4H19C20.1 4 21 4.9 21 6V20C21 21.1 20.1 22 19 22H5C3.89 22 3 21.1 3 20V6C3 4.9 3.89 4 5 4H6V2H8V4H16V2H18V4ZM5 20H19V10H5V20ZM5 8H19V6H5V8ZM11 13H7V17H11V13Z" fill="current"/>
</svg>
